import {useEffect} from "react"
import {useLocation, useOutletContext} from "react-router-dom"
import {useSWRConfig} from "swr"

import {useStableNavigate} from "../utilities/StableNavigateContext"
import {wrappedPost} from "../utilities/AxiosHelper"
import {removeToken} from "../utilities/useToken"

function Logout(props) {
    const {pathname} = useOutletContext()
    const navigate = useStableNavigate()
    const {state} = useLocation()

    const {mutate} = useSWRConfig()
    const clearCache = () => mutate(() => true, undefined, {revalidate: false})

    useEffect(() => {
        // Hack to prevent this from being called more than once during re-renders
        // A better fix is to figure out why re-renders are happening
        if (pathname === "/logoutnav") {
            wrappedPost("/logout")
                .then(() => {
                    clearCache()
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    removeToken()
                    navigate("/login", {replace: true, state: state})
                })
        }
    }, [navigate, pathname, state])
    return <p>Logging out...</p>
}

export default Logout
